export default "__VITE_ASSET__BKvTrVHW__"